import { DeliveryType, LOCALIZED } from '@libs/core';

export function createProductVariantInventoryKey(variantId: string, deliveryType: string) {
    const deliveryKeys = {
        [DeliveryType.BOPIS as string]: DeliveryType.BOPIS as string,
        [DeliveryType.SDD as string]: DeliveryType.SDD as string,
    };

    const deliveryKey = deliveryKeys[deliveryType] ?? LOCALIZED.webInventory;

    return `${variantId}-${deliveryKey}`;
}
